export class CompPackOrderRentalValues {

    constructor(rentalItemNr: number, rentalPersTypeNr: number, packagePositionNr: number) {
        this.rentalItemNr = rentalItemNr;
        this.rentalPersTypeNr = rentalPersTypeNr;
        this.packagePositionNr = packagePositionNr;
    }

    rentalItemNr: number;
    rentalPersTypeNr: number;
    packagePositionNr: number;
}